import { api, wp } from '@/utils/client';

export default {
    state: {
        loginResult: false,
    },
    mutations: {
        loginToBookblockHub(state, {token, user}) {
            state.accessToken = token;
            state.user = user;
        },
    },
    actions: {
        async loginToBookblockHub(context, credentials) {
            const {data: {apiToken, wpToken}} = await api.post('/login', credentials);
            if (!apiToken || !wpToken) return {status: 'error'};
            context.commit('loginToBookblockHub', {status: 'success'});
            localStorage.setItem('wp_token', wpToken);
            localStorage.setItem('api_token', apiToken);
            wp.defaults.headers.Authorization = `Bearer ${wpToken}`;
            api.defaults.headers.Authorization = `Bearer ${apiToken}`;
            await context.dispatch('fetchUserTeams');
            return {status: 'success'};
        },
        async signUpToBookblockHub(context, data) {
            try {
                const response = await api.post('/sign-up', data);
                //context.commit('loginToBookblockHub', response.data);
                return response;
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async verifySignUpToken(context, token) {
            try {
                const response = await api.get(`/sign-up?token=${token}`);
                return response;
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async teamSignUpToBookblockHub(context, data) {
            try {
                const response = await api.post('/team-sign-up', data);
                return response;
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async clearAuthCookies() {
            console.log('cleaning');
            try {
                const response = await api.post('/clear-auth-cookies');
                return response;
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        async onLogout({dispatch}) {
            localStorage.removeItem('wp_token');
            localStorage.removeItem('api_token');
            localStorage.removeItem('selectedTeam');
            wp.defaults.headers.Authorization = undefined;
            api.defaults.headers.Authorization = undefined;
            await dispatch("clearAuthCookies");
            const cookies = document.cookie.split(';');

            // This does not work, as those are httponly cookies. Leaving this here just for case. Using clearAuthCookies instead.
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i];
                const eqPos = cookie.indexOf('=');
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

                if (name.trim().startsWith('wordpress_logged_in_') ||
                    name.trim().startsWith('wordpress_sec_') ||
                    name.trim().startsWith('wp_woocommerce_session_') ||
                    name.trim() === 'wordpress_test_cookie') {
                    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
                }
            }
        },
    },
};
